export default __webpack_public_path__ + "static/media/segoeui-regular.2943eb3b.woff2";